const config = {
  apiUrl: process.env.NODE_ENV === 'production' 
    ? 'https://nblpatio.nbl.dev.br/api'
    : 'http://localhost:5001/api'
};

export default config;
